import api, { ApiResponse } from './api';

export interface FaceEmbedding {
  employeeId: number;
  name: string;
  departmentName?: string;
  descriptors: { label: string; values: number[] }[];
}

export interface FacePunchResponse {
  employeeId: number;
  employeeName: string;
  direction: 'GIRIS' | 'CIKIS';
  time: string;
  confidence: number;
}

export interface FaceStatus {
  employeeId: number;
  registered: boolean;
  faceCount: number;
}

const faceService = {
  /** Tum personellerin yuz embedding'lerini getir */
  getEmbeddings: (departmentId?: number): Promise<ApiResponse<FaceEmbedding[]>> => {
    const params = departmentId ? `?departmentId=${departmentId}` : '';
    return api.get(`/face/embeddings${params}`);
  },

  /** Personel yuz kaydi olustur */
  register: (employeeId: number, descriptors: { label: string; values: number[] }[], replaceExisting = true): Promise<ApiResponse<{ saved: number }>> => {
    return api.post('/face/register', { employeeId, descriptors, replaceExisting });
  },

  /** Yuz tanima ile punch (giris/cikis) */
  punch: (employeeId: number, confidence: number): Promise<ApiResponse<FacePunchResponse>> => {
    return api.post('/face/punch', { employeeId, confidence });
  },

  /** Personelin yuz kayit durumunu kontrol et */
  getStatus: (employeeId: number): Promise<ApiResponse<FaceStatus>> => {
    return api.get(`/face/status/${employeeId}`);
  },

  /** Personelin yuz kaydini sil */
  deleteEmbeddings: (employeeId: number): Promise<ApiResponse<{ deleted: number }>> => {
    return api.delete(`/face/embeddings/${employeeId}`);
  },
};

export default faceService;
